// extracted by mini-css-extract-plugin
export var more = "MoreText-module--more--fdbaf";
export var text = "MoreText-module--text--71833";